<div
  class="size-{{ size }} {{ iconKey }} {{ cursorType }}"
  [ngClass]="{ disabled: isDisabled || !activePointerEvents, exceptions: getExceptionsWidth() }"
  (click)="isDisabled ? $event.stopImmediatePropagation() : handleClick($event)"
  (mouseenter)="mouseenter()"
  (mouseleave)="mouseleave()">
  <img
    alt="icon"
    fetchPriority="high"
    loading="eager"
    [ngClass]="{ disabled: isDisabled }"
    [src]="enableForceHover && isHover ? icons[iconKey][eStatusIconEnum.hover] : srcImage" />
</div>
